
import { Component, OnInit } from '@angular/core';
import {Inject} from '@angular/core';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectImage, ProjectMaterial } from 'src/app/objects/Project';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-contractor-image-upload',
  templateUrl: './contractor-image-upload.component.html',
  styleUrls: ['./contractor-image-upload.component.css']
})
export class ContractorImageUploadComponent implements OnInit {
 
  selectedFile: File | null = null;
  base64String: string | null = null;

  form: FormGroup;
  fileName!: string;
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 

  ProjectId: number | undefined ;
  project: Project |any;

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }
  constructor( private route: ActivatedRoute,  private router: Router,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ContractorImageUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
    ) { 
      this.form =  this.createFormGroup();   
     }

     createFormGroup()  
  {
    return new FormGroup({
    id: new FormControl(),
    title:  new FormControl(),      
    description:  new FormControl(),          
    fileName:  new FormControl(),  
     uploadDate:  new FormControl(),        
       imageContent:  new FormControl(),        
      }
    )
  }
    ngOnInit(): void {
 

      if (this.data != undefined) {
         
        this.loadProject(this.data.projectId);
      }
    
    }

    loadProject(projectId: number) {
  
      this.projectService.getProject(projectId).subscribe((project) => {
        this.project = project;
       
          
      });
   
    }


     uploadFile() {
      if (!this.selectedFile) {
        alert('No file selected!');
        return;
      }
      this.fileName = this.selectedFile.name;
      const reader = new FileReader();
   
      reader.onload = (e) => {
       if(e.target != undefined)
        this.base64String = e.target.result as string;
        // Call a service to save this base64 string to the server.
      
        
      this.uploadImage2();
      };
      reader.readAsDataURL(this.selectedFile); 
    } 


 

    uploadImage2() {
      if (this.base64String) {
   
  
        let projectImage: ProjectImage = {
          //  id: 0, // Set the appropriate value
          title: 'Image Title',
          description: 'Image Description',
          uploadDate: new Date(),
          fileName: '',
          imageContent: this.base64String,
          id: 0
        };


 
        let newProjectImageform: ProjectImage  = Object.assign(this.form.value); 
  
        projectImage.title = newProjectImageform.title;
        projectImage.fileName = this.fileName;
        projectImage.description = newProjectImageform.description; 
        
        let newProject: Project   = Object.assign({}, this.project); 
 
      newProject.projectImage = newProject.projectImage || [];
      
        newProject.projectImage.push(projectImage);
       


        this.projectService.updateProject(newProject)
        .subscribe(res => {
          
            // Simple message.
            this.openSnackBar();
            this.isLoadingResults = false;
            console.log('Project edited successfully!');
            this.loadProject(this.project?.id);
          }, (err) => {
            console.log(err);
            this.isLoadingResults = false;
          });
              
      console.debug(projectImage);
      };   
    }
 
 
   

  

convertFileToBase64(file: File): string {
  const reader = new FileReader();
let string64= '';
  reader.onload = (e) => {
    const base64String = e.target?.result as string;
    console.log(base64String); // This is the base64 string representation of the selected file.
    string64 = base64String;
  };

  reader.readAsDataURL(file);
  return string64
}
  openSnackBar() {
    this.snackBar.open('Successfully Added Material To Project');
  }
 
}

